import { defineComponent as _defineComponent } from 'vue';
import { SButton, SIcon, SLoader } from '@strana-artw/ui-kit';
import { ref } from 'vue';
import { ErrorOutput } from '@/shared/ui/outputs';
import SimpleOverlay from '@/shared/ui/SimpleOverlay.vue';
import VFadeTransition from '@/shared/ui/transitions/VFadeTransition.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SidePageLayout',
  props: {
    pending: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    theme: {
      default: 'milk'
    },
    narrow: {
      type: Boolean,
      default: false
    },
    scrollArea: {
      type: Boolean,
      default: true
    },
    wrapperClass: {
      default: undefined
    },
    closeButtonClass: {
      default: undefined
    }
  },
  emits: ["close"],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var scrollAreaEl = ref(null);
    function handleClose() {
      emit('close');
    }
    expose({
      scrollAreaEl: scrollAreaEl
    });
    return {
      __sfc: true,
      emit: emit,
      scrollAreaEl: scrollAreaEl,
      handleClose: handleClose,
      SButton: SButton,
      SIcon: SIcon,
      SLoader: SLoader,
      ErrorOutput: ErrorOutput,
      SimpleOverlay: SimpleOverlay,
      VFadeTransition: VFadeTransition
    };
  }
});